
export default {
  data () {
    return {
      tableFields: [
        { prop: 'userid', label: '用户ID', width: 100 },
        { prop: 'realname', label: '用户真实姓名', width: 120 },
        { prop: 'cellphone', label: '用户手机号', width: 150 },
        { prop: 'usertype', label: '用户类型', width: 100 },
        { prop: 'task_types', label: '任务类型', width: 200 },
        { prop: 'tags', label: '标签', width: 200 },
        { prop: 'current_location', label: '当前心跳位置', width: 200 },
        { prop: 'id_card_location', label: '身份证覆盖位置', width: 200 },
        { prop: 'all_approved_rate', label: '综合做单准确率', width: 120 },
        { prop: 'order_rank_avg', label: '做单质量(平均分)', width: 150 },
        { prop: 'order_canceled_avg', label: '恶意弃单率(%)', width: 120 },
        { prop: 'order_canceled_cnt', label: '恶意弃单次数', width: 120 },
        { prop: 'order_total_cnt', label: '抢单总次数', width: 120 },
        { prop: 'all_approved_cnt', label: '做单数量', width: 100 },
        { prop: 'customer_count', label: '参与客户数量', width: 120 },
        { prop: 'evidence_types', label: '证据类型', width: 100 },
        { prop: 'registertime', label: '注册时间', width: 160 },
        { prop: 'last_active_tp', label: '最后活跃时间', width: 160 },
        { prop: 'cumulative_bounty', label: '累计做单金额', width: 150 },
      ],
      detailFields: [
        { prop: 'userid', label: '用户ID' },
        { prop: 'realname', label: '用户真实姓名' },
        { prop: 'cellphone', label: '用户手机号' },
        { prop: 'usertype', label: '用户类型' },
        { prop: 'task_types', label: '任务类型' },
        { prop: 'tags', label: '标签', allowToggle: true },
        { prop: 'tag_groups', label: '标签组' },
        { prop: 'current_location', label: '当前心跳位置' },
        { prop: 'id_card_location', label: '身份证覆盖位置' },
        { prop: 'order_rank_info', label: '做单质量(平均分)' },
        { prop: 'order_canceled_avg', label: '恶意弃单率(%)' },
        { prop: 'order_canceled_cnt', label: '恶意弃单次数' },
        { prop: 'order_total_cnt', label: '抢单总次数' },
        { prop: 'all_approved_cnt', label: '做单(已通过)数量' },
        { prop: 'evidence_types', label: '证据类型' },
        { prop: 'registertime', label: '注册时间' },
        { prop: 'last_active_tp', label: '最后活跃时间' },
        { prop: 'cumulative_bounty', label: '累计做单金额(元)' },
        { prop: 'customer_count', label: '参与客户数量' },
        { prop: 'customer_ids', label: '参与客户列表', allowToggle: true },
        { prop: 'order_covered_nonsubmitted_locations', label: '签到未提交工单覆盖', allowToggle: true },
        { prop: 'order_covered_rejected_locations', label: '提交未通过工单覆盖', allowToggle: true },
        { prop: 'order_covered_approved_locations', label: '审核通过工单覆盖', allowToggle: true },
        { prop: 'order_measurement_all_approved_rate', label: '综合做单数据' },
      ],
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/user-order-stat/userOrderStat.mixins.js